module.exports = __webpack_public_path__ + "static/media/employee_history.c9357a68.png";